/**
 * Registry of every localStorage key the app uses. Values are the stored key names: changing one
 * drops what users already saved under it.
 */
export enum StorageKey {
  Basemap = 'ui.basemap',
  Stations = 'ui.stations',
  Trails = 'ui.trails',
  Units = 'ui.units',
}
